class ErrorCodeManager {
    /**
    * The constructor function is called when the object is created, and it's used to set up the
    * object.
    * @param obj @type {Object} - get global class object
    */
    constructor(obj) {
       
    }

    getVideoErrorCode(eventName, eventData) {
        let event_error_code = eventData.event_error_code;
        let event_error_message = eventData.event_error_message;
        if (eventData.event_error_code == 0 || eventData.event_error_code == "") {
            event_error_code = "PLAYER_UNDEFINE_101";
        }
        if (eventData.event_error_message == "") {
            event_error_message = "player undefine error";
        }
        return {"ec":event_error_code, "em":event_error_message}; 
    }

    getAdsErrorCode(eventName, eventData) {
        let event_error_code = eventData.event_error_code;
        let event_error_message = eventData.event_error_message;
        if (eventData.event_error_code == 0 || eventData.event_error_code == "") {
            event_error_code = "ADS_UNDEFINE_201";
        }
        if (eventData.event_error_message == "") {
            event_error_message = "player ads undefine error";
        }
        return {"ec":event_error_code, "em":event_error_message}; 
    }
}

export default ErrorCodeManager;